import request from '@/utils/request'

// 分页查询i18n值
export function queryI18nValuePage(params) {
  return request({
    url: '/v3/manager/i18n/queryI18nValuePage',
    method: 'post',
    data: params
  })
}
export function addI18nValue(params) {
  return request({
    url: '/v3/manager/i18n/addI18nValue',
    method: 'post',
    data: params
  })
}
export function editI18nValue(params) {
  return request({
    url: '/v3/manager/i18n/editI18nValue',
    method: 'post',
    data: params
  })
}
export function deleteI18nValue(params) {
  return request({
    url: '/v3/manager/i18n/deleteI18nValue?id=' + params.id,
    method: 'post',
    data: params
  })
}
export function getProjectList(params) {
  return request({
    url: '/v3/manager/i18n/getProjectList',
    method: 'get',
    data: params
  })
}
export function getModuleByProject(params) {
  return request({
    url: '/v3/manager/i18n/getModuleByProject?project=' + params.project,
    method: 'get',
    data: params
  })
}
// 上传文件
export function upload(params) {
  var formData = new FormData()
  formData.append('file', params.raw)
  return request({
    url: '/v3/manager/i18n/upload',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: formData
  })
}

function fetch_POST (url, data, headers) {
  return request({
    url,
    method: 'post',
    data,
    headers
  })
}

export function getModuleValueMap (language,project,module) {// 获取对应语言包
  return fetch_POST('/v3/manager/i18n/getModuleValueMap', { module, project  }, { language })
}
